import React from "react";

// ASSET --- Arrow Up
export const arrowUp = (<svg rpl="" fill="currentColor" height="16" icon-name="arrow-up" viewBox="0 0 20 20" width="16" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.877 19H7.123A1.125 1.125 0 0 1 6 17.877V11H2.126a1.114 1.114 0 0 1-1.007-.7 1.249 1.249 0 0 1 .171-1.343L9.166.368a1.128 1.128 0 0
  1 1.668.004l7.872 8.581a1.25 1.25 0 0 1 .176 1.348 1.113 1.113 0 0 1-1.005.7H14v6.877A1.125 1.125 0 0 1 12.877 19ZM7.25 17.75h5.5v-8h4.934L10
  1.31 2.258 9.75H7.25v8ZM2.227 9.784l-.012.016c.01-.006.014-.01.012-.016Z"/>
</svg>)

// ASSET --- Arrow Down
export const arrowDown = (<svg rpl="" fill="currentColor" height="16" icon-name="arrow-down" viewBox="0 0 20 20" width="16" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 20a1.122 1.122 0 0 1-.834-.372l-7.872-8.581A1.251 1.251 0 0 1 1.118 9.7 1.114 1.114 0 0 1 2.123 9H6V2.123A1.125 1.125 0 0 1 7.123
  1h5.754A1.125 1.125 0 0 1 14 2.123V9h3.874a1.114 1.114 0 0 1 1.007.7 1.25 1.25 0 0 1-.171 1.345l-7.876 8.589A1.128 1.128 0 0 1 10 20Zm-7.684-9.75L10
  18.69l7.741-8.44H12.75v-8h-5.5v8H2.316Zm15.469-.05c-.01 0-.014.007-.012.013l.012-.013Z"/>
</svg>)

// ASSET --- Google Arrow Up (for navigation)
export const navArrowUp = (<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="32" viewBox="0 -960 960 960" width="32">
  <path d="M434.5-633.848 247.826-447.174q-13.674 13.674-32.065 13.294-18.391-.381-32.065-14.055-12.674-13.674-13.055-32.065-.38-18.391
  13.294-32.065l264-264q6.717-6.718 14.913-9.816 8.195-3.097 17.152-3.097t17.152 3.097q8.196 3.098 14.913 9.816l264.239 264.239q12.914
  12.913 12.914 31.565t-12.914 32.326q-13.674 13.674-32.445 13.674-18.772 0-32.446-13.674L525.5-633.848v436.478q0 19.153-13.174
  32.327T480-151.869q-19.152 0-32.326-13.174T434.5-197.37v-436.478Z"/>
</svg>)

// ASSET --- Google Menu icon (for navigation)
export const menuIcon = (<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="24" viewBox="0 -960 960 960" width="24">
  <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/>
</svg>)